import { populateSearchParams } from './url';

import type { StoryblokLink } from '@widget/types/storyblok';

const SEPARATOR = ',';

export function getStringParams(input: string) {
  return input.split(SEPARATOR).map((param) => param.trim());
}

export function populateLinkSearchParams({
  link,
  source,
  params,
}: {
  link: StoryblokLink;
  source: Record<string, string | string[] | undefined>;
  params: string[];
}): StoryblokLink {
  return {
    ...link,
    url: populateSearchParams({ original: link.url, source, params }),
    cached_url: populateSearchParams({ original: link.cached_url, source, params }),
  };
}
